export default __webpack_public_path__ + "static/media/AltMode.1395c229.png";